/* eslint-disable react/forbid-prop-types,react/require-default-props */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Link } from '../../../../containers/Link/index';
import { CourseAdminNavToggleIcon } from '../icons';

import { courseNavigationListChevron } from '../../../../containers/OLTopBar/styles.scss';
import { ActiveMenuLinkIndicator } from '../components';

export class CourseModuleLink extends PureComponent {
  static propTypes = {
    link: PropTypes.any.isRequired,
    currentModuleSet: PropTypes.string,
    makeSetCurrentModuleSetAction: PropTypes.func.isRequired,
  };

  render() {
    const {
      link,
      currentModuleSet,
      makeSetCurrentModuleSetAction,
    } = this.props;
    const inUse =
      (link.get('type') === 'module-set' &&
        link.get('name') === currentModuleSet) ||
      (link.get('type') === 'default-module-set' &&
        currentModuleSet === 'Default');
    const linkAction = inUse
      ? makeSetCurrentModuleSetAction({}).toJS()
      : makeSetCurrentModuleSetAction({
          setName:
            link.get('type') === 'default-module-set'
              ? 'Default'
              : link.get('name'),
        }).toJS();
    return (
      <li
        key={link.get('index')}
        className={classNames('item', {
          'in-use': inUse,
        })}
      >
        <ActiveMenuLinkIndicator isActive={inUse} />
        <Link
          className="module-set"
          to={linkAction}
          aria-current={inUse ? 'page' : null}
        >
          {link.get('name')}
          <span
            className={`course-navigation-chevron ${courseNavigationListChevron}`}
          >
            <CourseAdminNavToggleIcon expanded={false} />
            <span className="screen-reader-text">Expand modules menu</span>
          </span>
        </Link>
      </li>
    );
  }
}
